import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
    Redirect,
    Route,
    Switch,
    withRouter,
    useLocation,
} from 'react-router-dom';
import Routes from './constants/routes';
import {
    sendToPendo,
    initializePendo,
    updateMetricsObject,
} from './utils/helper/pendo';
import AppConfig from './features/app-config/app-config';
import { selectAppConfigs } from './features/app-config/app-config-selector';
import LoginCallback from './features/login/login-callback';
import {
    selectOriginalRedirectUrl,
    selectUserAuthenticationStatus,
} from './features/login/login-selector';
import Welcome from './features/welcome/welcome';
import Register from './features/register/register';
import GeneralErrorPage from './components/general-error/GeneralErrorPage';

const pendoImplementation = (pathname: string) => {
    initializePendo();
    updateMetricsObject({ name: pathname });
    sendToPendo();
};

const AppRouter = () => {
    const location = useLocation();
    const baseClassName = 'app-layout';
    const isUserAuthenticated = useSelector(selectUserAuthenticationStatus);
    const originalRedirectUrl: any = useSelector(selectOriginalRedirectUrl);
    const appConfigs = useSelector(selectAppConfigs);
    const redirectPath = originalRedirectUrl;

    pendoImplementation(location.pathname);

    const initializeOneTrustBanner = () => {
        const script = document.createElement('script');
        script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
        script.setAttribute('data-domain-script', appConfigs.ONETRUST_APP_ID);
        script.type = 'text/javascript';

        const scriptFunction = document.createElement('script');
        scriptFunction.type = 'text/javascript';
        scriptFunction.innerHTML = 'function OptanonWrapper() { }';

        document.head.appendChild(script);
        document.head.appendChild(scriptFunction);
    };

    useEffect(() => {
        if (Object.keys(appConfigs).length > 0) {
            initializeOneTrustBanner();
        }
    }, [appConfigs]);

    return (
        <div className="main-content">
            <main className={`${baseClassName}`}>
                <div id="content" />
                {/* screen reader does not start reading the whole content after skipping to main content */}
                <section className={`${baseClassName}__body`}>
                    {Object.keys(appConfigs).length === 0 ? (
                        <AppConfig />
                    ) : (
                        // eslint-disable-next-line react/jsx-no-useless-fragment
                        <>
                            {isUserAuthenticated ? (
                                <Switch>
                                    (
                                    <>
                                        <Redirect
                                            from={
                                                appConfigs.USE_KEYCLOAK
                                                    ? `${Routes.KEYCLOAK_CALLBACK}*`
                                                    : `${Routes.LOGIN_CALLBACK}*`
                                            }
                                            to={redirectPath}
                                        />
                                        <Redirect
                                            exact
                                            from={`${Routes.ROOT}`}
                                            to={redirectPath}
                                        />
                                    </>
                                    )
                                </Switch>
                            ) : (
                                <Switch>
                                    <Route
                                        exact
                                        path={[`${Routes.ERROR_PAGE}`]}
                                        component={GeneralErrorPage}
                                    />
                                    <Route
                                        exact
                                        path={
                                            appConfigs.USE_KEYCLOAK === 'true'
                                                ? Routes.KEYCLOAK_CALLBACK
                                                : Routes.LOGIN_CALLBACK
                                        }
                                        component={LoginCallback}
                                    />
                                    <Redirect
                                        exact
                                        from={`${Routes.ROOT}`}
                                        to={Routes.WELCOME_ECR_ID}
                                    />
                                    <Route
                                        path={Routes.WELCOME_ECR_ID}
                                        component={Welcome}
                                    />
                                    <Route
                                        path={Routes.REGISTER}
                                        component={Register}
                                    />
                                </Switch>
                            )}
                        </>
                    )}
                </section>
            </main>
        </div>
    );
};

export default withRouter(AppRouter);
